module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageMobile_EN.0777e89e.png";